var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacebookBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.849,
    height: 26.849,
    viewBox: "0 0 26.849 26.849",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.972,1.5H2.877A2.878,2.878,0,0,0,0,4.377v21.1a2.878,2.878,0,0,0,2.877,2.877H11.1V19.221H7.327v-4.3H11.1V11.65c0-3.725,2.217-5.782,5.614-5.782a22.875,22.875,0,0,1,3.327.29V9.814H18.169a2.148,2.148,0,0,0-2.422,2.321v2.79h4.122l-.659,4.3H15.747v9.128h8.225a2.878,2.878,0,0,0,2.877-2.877V4.377A2.878,2.878,0,0,0,23.972,1.5Z",
    transform: "translate(0 -1.5)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Facebook_black.9f8eb260.svg";
export { ForwardRef as ReactComponent };